// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2jv5H","col":"CardReaderDesc_col__252sd","label":"CardReaderDesc_label__1Btbk"};